import { useSyncExternalStore } from "react";

const KEY = "urwan_wishlist";

function load() {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
        return Array.isArray(raw) ? raw.filter((p) => p && p.productId) : [];
    } catch {
        return [];
    }
}

let items = load();
let open = false;
let snap = { items, open };
const listeners = new Set();

function save() {
    try {
        localStorage.setItem(KEY, JSON.stringify(items));
    } catch {}
}

function rebuild() {
    snap = { items, open };
    save();
    listeners.forEach((l) => l());
}

export function wishlistToggle(item) {
    const exists = items.some((p) => p.productId === item.productId);
    items = exists ? items.filter((p) => p.productId !== item.productId) : [...items, item];
    rebuild();
    return !exists;
}

export function wishlistRemove(productId) {
    items = items.filter((p) => p.productId !== productId);
    rebuild();
}

export function wishlistSetOpen(v) {
    open = v;
    rebuild();
}

function subscribe(l) {
    listeners.add(l);
    return () => listeners.delete(l);
}

export function useWishlist() {
    const state = useSyncExternalStore(subscribe, () => snap);
    return {
        items: state.items,
        open: state.open,
        has: (id) => state.items.some((i) => i.productId === id),
        toggle: wishlistToggle,
        remove: wishlistRemove,
        setOpen: wishlistSetOpen,
    };
}
